import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import TableHeaderCell from "components/reusable/TableHeaderCell";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";

const BioMetricTable = ({ employeeList }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="p-3">
        <div className="rounded-lg overflow-x-auto relative border">
          <table className="dark:text-gray-400 w-full text-xs text-left text-[#6c6c6c] ">
            <thead className="border-[#E1E6EE] bg-[#E1E6EE] text-xs text-gray-900 border dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("DATE")} />
                <TableHeaderCell text={t("EMPLOYEE_ID")} />
                <TableHeaderCell text={t("EMPLOYEE_NAME")} />
                <TableHeaderCell text={t("PUNCH_IN_TIME")} />
                <TableHeaderCell text={t("PUNCH_OUT_TIME")} />
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex justify-start">
                    <span>{t("PUNCH_IN_LOCATION")}</span>
                  </div>
                </th>

                <th scope="col" className="cursor-pointer py-3 px-6 ">
                  <div className="flex justify-start">
                    <span>{t("PUNCH_OUT_LOCATION")}</span>
                  </div>
                </th>
                <th className="py-3 px-6 text-center" scope="col">
                  {t("TOTAL_BREAK_TIME")}
                </th>
                <th scope="col" className="text-center py-3 px-6 ">
                  {t("WORKING_HOURS")}
                </th>
              </tr>
            </thead>
            <tbody>
              {employeeList &&
                employeeList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:border-gray-700 dark:bg-gray-800 ">
                      <td className="py-4 px-6 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY")}</td>
                      <td className="border-r text-gray-900 py-4 px-6 ">{item?.employee?.employeeId}</td>
                      <td className="border-r py-4 px-6 text-gray-900">{item?.employee?.name}</td>
                      <td className="py-4 border-r text-gray-900 px-6 ">{item?.punchInDateTime ? dayjs(item?.punchInDateTime).format("h:mm:ss A") : "N/A"}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.punchOutDateTime ? dayjs(item?.punchOutDateTime).format("h:mm:ss A") : "N/A"}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.punchInLocation || "N/A"}</td>

                      <td className="py-4 px-6 border-r text-gray-900">{item?.punchOutLocation || "N/A"}</td>
                      <td className="py-4 px-6 border-r text-left text-gray-900">{helper.calculateTotalBreakTime(item?.breaks, item?.endBreak)}</td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {helper.calculateTotalWorkTime({
                          punchInDateTime: item?.punchInDateTime,
                          punchOutDateTime: item?.punchOutDateTime,
                          breakEndTime: item?.endBreak,
                          breakTime: item?.breaks,
                        })}
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(employeeList) ? (
                <tr className="dark:border-gray-700 bg-white border-b text-center dark:bg-gray-800 ">
                  <td className="py-4 px-6 border-r" colSpan={10}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BioMetricTable;
